import { createContext, useContext, useState } from 'react';

const LayoutContext = createContext();

export const LayoutProvider = ({ children }) => {
    const [isFullPage, setIsFullPage] = useState(true);

    return (
        <LayoutContext.Provider value={{ isFullPage, setIsFullPage }}>
            {children}
        </LayoutContext.Provider>
    );
};

export const useLayout = () => useContext(LayoutContext);
